/**
 * FLOW ENGINE CONFIGURATION
 * Environment variable alapú konfiguráció
 */

// Environment variable-ből vagy fallback
const FLOW_ENGINE_BASE_URL = process.env.REACT_APP_FLOW_ENGINE_URL || 'http://localhost:8000';

export const FLOW_ENGINE_ENDPOINTS = {
  base: FLOW_ENGINE_BASE_URL,
  health: `${FLOW_ENGINE_BASE_URL}/health`,
  flows: `${FLOW_ENGINE_BASE_URL}/api/flows`,
  executions: `${FLOW_ENGINE_BASE_URL}/api/executions`,
  scheduler: `${FLOW_ENGINE_BASE_URL}/api/scheduler`,
};

export function getFlowExecutionUrl(flowId: string): string {
  return `${FLOW_ENGINE_BASE_URL}/api/flows/${flowId}/execute`;
}

export function getExecutionStatusUrl(executionId: string): string {
  return `${FLOW_ENGINE_BASE_URL}/api/executions/${executionId}`;
}

export function getExecutionCancelUrl(executionId: string): string {
  return `${FLOW_ENGINE_BASE_URL}/api/executions/${executionId}/cancel`;
}
